/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */
export const makeFirstLetterUppercase = (str) => str.charAt(0).toUpperCase() + str.slice(1)

export const removeDiacritics = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
